import { isCreditTransaction } from "@custom-types/credit-type-guards";

/**
 * @returns true if the object has the expected pagination response structure
 */
export function isActivityApiPaginatedResponse(response) {
  if (!response || typeof response !== "object") {
    return false;
  }
  const toCheck = response;
  return !!toCheck.data && toCheck.data.every(isCreditTransaction) && typeof toCheck.totalCount === "number" && typeof toCheck.pageSize === "number" && (typeof toCheck.before === "string" || toCheck.before === null) && (typeof toCheck.after === "string" || toCheck.after === null);
}